import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type ButtonOutlinedClasses = 'root' | 'disabled';

const buttonOutlinedStyles = makeStyles<ISpcTheme, ButtonOutlinedClasses>(
  theme => ({
    root: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.secondary.main,
      border: `1px solid ${theme.palette.secondary.main}`,
      minWidth: 120,
      [theme.breakpoints.down('sm')]: {
        minWidth: 100,
      },
    },
    disabled: {
      border: `1px solid rgba(0, 0, 0, 0.26)`,
    },
  }),
  { name: 'Customise_ButtonOutlined' },
);

export default buttonOutlinedStyles;
